// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2V2Db","boxTitle":"Qualiphy_boxTitle__1Al9e","box":"Qualiphy_box__2uGf9","toggleWrap":"Qualiphy_toggleWrap__23mWL"};